import React, { useState, useEffect } from "react";

const FloatingActionButton = ({ scrollContainer }) => {
  const [scrollDirection, setScrollDirection] = useState("down");
  const [prevScrollPos, setPrevScrollPos] = useState(
    scrollContainer ? scrollContainer.scrollTop : 0
  );
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    if (!scrollContainer) return;

    const handleScroll = () => {
      const currentScrollPos = scrollContainer.scrollTop;
      const atBottom =
        scrollContainer.clientHeight + currentScrollPos >=
        scrollContainer.scrollHeight - 5;

      setIsAtBottom(atBottom);

      if (currentScrollPos > prevScrollPos) {
        setScrollDirection("down");
      } else if (currentScrollPos < prevScrollPos) {
        setScrollDirection("up");
      }

      setPrevScrollPos(currentScrollPos);
    };

    scrollContainer.addEventListener("scroll", handleScroll);
    return () => {
      scrollContainer.removeEventListener("scroll", handleScroll);
    };
  }, [scrollContainer, prevScrollPos]);

  const handleClick = () => {
    if (scrollContainer) {
      if (isAtBottom || scrollDirection === "up") {
        scrollContainer.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        scrollContainer.scrollTo({
          top: scrollContainer.scrollHeight,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <button
      className="floating-action-button"
      onClick={handleClick}
      aria-label={
        isAtBottom || scrollDirection === "up"
          ? "Scroll to Top"
          : "Scroll to Bottom"
      }
    >
      <i
        className={`bi ${
          isAtBottom || scrollDirection === "up"
            ? "bi-arrow-up-short"
            : "bi-arrow-down-short"
        }`}
      ></i>
    </button>
  );
};

export default FloatingActionButton;
